import { Property } from "src/interfaces/IProperty";
import { DEFAULT_FLOOR_NAME, Floor, Zone } from "src/interfaces/IZone";

export namespace Sorter {
  export const property = (p1: Property, p2: Property) =>
    p1.property_name.localeCompare(p2.property_name);
  export const floor = (f1: Floor, f2: Floor) =>
    f1.name === DEFAULT_FLOOR_NAME ? -1 : f1.name.localeCompare(f2.name);
  export const zone = (z1: Zone, z2: Zone) =>
    z1.zone_name.localeCompare(z2.zone_name);
}

const getFloorsOfZones = (zones: Zone[]): Floor[] => {
  const floors = zones.map((zone) => zone.floor);
  return Array.from(new Set(floors)).map((f) => ({ name: f }));
};

// eslint-disable-next-line import/prefer-default-export
export { getFloorsOfZones };
